<div class="form-floating">
  @if (!isEditing()) {
    <input
      type="text"
      class="form-control"
      readonly
      tabindex="0"
      [id]="previewId"
      [value]="formattedPreviewText()"
      [placeholder]="placeholder"
      (focus)="onPreviewFocus()"
    />
  } @else {
    <input
      #salaryNumberInput
      [id]="inputId"
      type="text"
      class="form-control"
      autocomplete="off"
      inputmode="decimal"
      [placeholder]="placeholder"
      [formControl]="control"
      (blur)="onNumberBlur()"
      (keydown)="onKeydown($event)"
      (paste)="onPaste($event)"
    />
  }
  <label [attr.for]="isEditing() ? inputId : previewId">{{ placeholder }}</label>
</div>
